import React, { Fragment, useState, useContext, useEffect } from 'react';
import AssignmentInd from '@material-ui/icons/AssignmentInd';
import {
  GlobalContext,
  OPEN_WIDGET,
  CLOSE_WIDGET,
} from '@mummssoftware/global-context/GlobalContext';
import { Facesheet as FacesheetWidget } from '@mummssoftware/utils/constants';
import { StyledActionIcon } from '../../components';

/**
 * Opens Facesheet from the patient-dashboard upper ribbon. Facesheet has
 * `doNotShow: true` in widget config — not a grid tile or + menu item; see
 * `widgetConfig/buildPutWidgetConfigPayload.ts`.
 */
export const FacesheetMenu = () => {
  const globalContext = useContext(GlobalContext);
  const { widgetsOpen, widgetNamesOpen } = useContext(GlobalContext);

  const [isWidgetOpen, setWidgetOpen] = useState(false);

  useEffect(() => {
    // max open widget is 4
    if (widgetsOpen.length >= 4) {
      setWidgetOpen(true);
    }
    if (widgetNamesOpen.includes(FacesheetWidget)) {
      setWidgetOpen(true);
    } else {
      setWidgetOpen(false);
    }
  }, [widgetsOpen, widgetNamesOpen]);

  // open facesheet
  const openWidgetFacesheet = () => {
    const widgetForm = {
      componentName: FacesheetWidget,
    };
    if (!isWidgetOpen) {
      globalContext.dispatch({
        type: OPEN_WIDGET,
        payload: widgetForm,
      });
    } else {
      setWidgetOpen(false);
      globalContext.dispatch({
        type: CLOSE_WIDGET,
        payload: widgetForm,
      });
    }
  };

  return (
    <Fragment>
      <StyledActionIcon
        Icon={AssignmentInd}
        disabled={isWidgetOpen}
        onClick={openWidgetFacesheet}
        id="facesheet-ribbon"
      />
    </Fragment>
  );
};
export default FacesheetMenu;
